import { useState, useRef, useEffect, RefObject } from 'react'
import { Div,onClick, TKlass } from './html'
import { ITag, TTagRec, ITagController } from './models/tag'
import * as model from './models/tag'
import { EditableTextBox, SearchBox } from './widgets';
import { useDismissOnEvent, Loft } from './widgets';

const D = Div
const L = console.log

export function Tag ({tag,k,remove} :
    {
        tag: string,
        k?: TKlass,
        remove?:() => void
    }
)
{
    return (
        <D k={['tag',remove && 'removable',k]}>
            <D k='name'>
                {tag}
            </D>
            {remove &&
                <D k={['remove','symbol']} {...onClick(() => remove())}>close</D>
             }
        </D>
    )
}

export function TagEditable ({
    tag,
    assigned,
    tags,
    control,
} : {
    tag: ITag
    assigned: boolean
    tags: TTagRec
    control: ITagController
})
{
    const [warn,setWarn] = useState<string>()
    return (
        <D k='tag-editable' key={tag.id}>
            <EditableTextBox {...{
                key: tag.id,
                k:['tag-name',warn && 'warn'],
                value: tag.name,
                onEdit: v => {
                    setWarn(undefined)
                    if (v && tags[v]) {
                        setWarn(`Tag ${v} already exists`)
                    }
                    return v
                },
                onSave: v => {
                    setWarn(undefined)
                    if (v) {
                        if (!tags[v]) {
                            tag.name = v
                            control.modify(tag)
                            return v
                        }
                        else {
                            setWarn(`Tag ${v} already exists`)
                            return tag.name
                        }
                    }
                }
            }}/>
            <D k='tag-icons'>
                {assigned && <D k={['icon','assigned','symbol']}
                    {...onClick(assigned ? () => control.unassign(tag) : () => control.assign(tag))}
                    >check</D>}
                {!assigned && <D k={['icon','add','symbol']}
                    {...onClick(assigned ? () => control.unassign(tag) : () => control.assign(tag))}
                    >add</D>}
                <D 
                    k={['icon','remove','symbol']}
                    {...onClick(() => control.remove(tag))}
                >close</D>
            </D>
        </D>
    )
}

export function TagBrowser (
{
    tags:$tags,
    name,
    control,
    clear,
}
: {
    tags: ITag[]
    name: string
    control: ITagController
    clear: () => void
})
{
    const tags = $tags.reduce((p,c) => {
        p[c.name] = c
        return p
    },{})

    const [query,setQuery] = useState<string>()
    const [searchActive,setSearchActive] = useState<boolean>(false)

    // Let SearchBox initialize its placeholder before entering edit mode.
    useEffect(() => setSearchActive(true),[])

    const ref = useRef<HTMLDivElement>(null)
    const allTags = control.all()
    const trimmedQuery = query?.trim() || ''
    const filteredTags = Object
        .values(allTags)
        .filter(_ => !trimmedQuery || _.name.toLowerCase().includes(trimmedQuery.toLowerCase()))
    const exactMatch = Object
        .values(allTags)
        .find(_ => _.name.toLowerCase() === trimmedQuery.toLowerCase())

    function createAndAssign () {
        if (!trimmedQuery || exactMatch) return
        const newTag = model.Tag.create(trimmedQuery)
        control.add(newTag)
        control.assign(newTag)
        setQuery(undefined)
    }

    useDismissOnEvent({ref,clear,options:{blur:false}})

    return (
        <D k='tag-modal'>
        <D k={['tag-browser']} ref={ref}>
            <Div k='titlebar'>
                <Div k='title'>Tags: {name}</Div>
                <Div k='dismiss' {...onClick(clear)}>close</Div>
            </Div>
            <D k='body'>
                <D k={['tags','assigned']}>
                    {
                        $tags.length
                        ? $tags.map(tag => (
                            <D k='tag'>
                                <D k='name'>{tag.name}</D>
                            </D>))
                        : <D k='none'>No tags assigned</D>
                    }
                </D>
                <D k='search'>
                    <Div k="icon">
                        <span className="symbols">search</span>
                    </Div>
                    <SearchBox
                        value={query}
                        emptyText='Search or create tag...'
                        k='searchbox'
                        editMode={searchActive}
                        onBlur={() => setSearchActive(false)}
                        onEdit={setQuery}
                        onSubmit={createAndAssign}
                    />
                </D>
                <D k='div'/>
                <D k='browser-tags'>
                    {trimmedQuery && !exactMatch &&
                        <D k='create-tag' {...onClick(createAndAssign)}>
                            <D k={['icon','symbol']}>add</D>
                            <D>Create “{trimmedQuery}”</D>
                        </D>
                    }
                    {filteredTags.length
                        ? filteredTags
                            //.sort((a,b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0)
                            .map(tag => ({
                                tag,
                                assigned: !!tags[tag.name]
                            }))
                            //.sort((a,b) => (a.assigned || b.assigned) && !(a.assigned && b.assigned) ? -1 : 0)
                            .map(({tag,assigned}) => <TagEditable tag={tag} tags={allTags} assigned={assigned} control={control}/>)
                        : !trimmedQuery && <D k='none'>No tags defined</D>
                    }
                </D>
            </D>
        </D>
    </D>
    )
}

export function Tags ({
        tags,
        name,
        control,
    } : {
        tags: ITag[]
        name: string
        control: ITagController
    })
{
    const [browser,setBrowser] = useState<boolean>(false)

    const empty = !tags.length

    return <Div k='tags'>
        {
            [
                ...tags
                //.sort(([a],[b]) => a.toLowerCase() < b.toLowerCase() ? -1 : a.toLowerCase() > b.toLowerCase() ? 1 : 0)
                .map(tag => 
                    <Tag
                        key={tag.name}
                        tag={tag.name}
                        remove={() => control.unassign(tag)}
                    />
                ),
                <Div
                    key='+'
                    k={['tag','add',empty && 'empty']}
                    onClick={!browser ? () => setBrowser(true) : () => {}}>
                    <D k='symbols'>add</D>
                    {empty && <D k='title'>ADD TAG</D>}
                </Div>
            ]
        }
        {browser && 
            <Loft target='space'>
                <TagBrowser
                    name={name}
                    tags={tags}
                    control={control}
                    clear={()=> setBrowser(false)}
                />
            </Loft>
        }
    </Div>
}
